import pro1 from '../assets/project1.jpeg'
import pro2 from '../assets/project2.jpeg'
import pro3 from '../assets/project3.jpeg'
import pro4 from '../assets/project4.jpeg'
import pro5 from '../assets/project5.jpeg'
import pro6 from '../assets/project6.jpeg'

export const projectCarddata = [
    {
        Imgsrc: pro6,
        title: "InkQuill",
        text: "Are you passionate about sharing your thoughts, experiences, and stories with the world!? Look no further! InkQuill is a user-friendly platform designed to empower individuals like you to create and publish compelling blogs effortlessly.",
        view:"https://ink-quill-blog.vercel.app/",
        sources: "https://github.com/shamil-ch/InkQuill-Blog"
    },
    
    {
        Imgsrc: pro5,
        title: "PromptFlow",
        text: "Discover & Share AI-Powered Prompts: PromptFlow is an open-source AI prompting tool for modern world to discover , create and share creative prompts",
        view:"https://promptflow-shamil7.netlify.app/",
        sources: "https://github.com/shamil-ch/PromptFlow"
    },
    
    {
        Imgsrc: pro4,
        title: "Hoobank UI",
        text: "The Next Generation Payment Method :Our team of experts uses a methodology to identify the credit cards most likely to fit your needs. We examine annual percentage rates, annual fees.",
        view:"https://hoobank-shamil7.netlify.app/",
        sources: "https://github.com/shamil-ch/HooBank"
    },
    {
        Imgsrc: pro1,
        title: "Stride Style UI",
        text: "Stride Style: Dynamic, user-centric shoe-selling interface reshaping online shopping. Our platform blends tech and fashion, providing curated, comfortable, and stylish footwear with variuos Prices.",
        view:"https://stride-shamil-7.netlify.app/",
        sources: "https://github.com/shamil-ch/stride-style"
    },

    {
        Imgsrc: pro2,
        title: "HomeFit ",
        text: "HomeFit: Vibrant fitness haven transforming workouts. Merge tech, expertise for tailored routines. Navigate seamlessly, access personalized workouts, sculpt your body comfortably at home.",
        view:"https://gym-app-shamil.netlify.app/",
        sources: "https://github.com/shamil-ch/GYM-App"
    },

    {
        Imgsrc: pro3,
        title: "Netflix clone UI",
        text: "FlixClone: Revolutionizing streaming with a Netflix-inspired UI. Browse, stream, and enjoy effortlessly. Elevate your entertainment experience comfortably from home with our seamless platform.",
        view:"https://netflix-clone-7.netlify.app/",
        sources: "https://github.com/shamil-ch/Netflix-React"
    },
];

